import React from 'react'
import { RouteComponentProps } from 'react-router';
import { ClampexType } from '../types/types';
import { store} from '../redux/store';
import { updateProduct, fetchProductCValues, fetchProductSizes, updateInputData, fetchMetadata, fetchMaterials } from '../redux/product/productActions';
import { useLocation } from 'react-router';
import queryString from 'query-string';
import { ProductInputData, ProductInputDataURL,  } from '../redux/product/productTypes';

interface ProductProps extends RouteComponentProps<any>, React.Props<any> {
    id: string
}

/**
 * This function sets the clampex type for the application at startup. Everything is based on the product type. (Not live only in beta state)
 */
const ProductLookup: React.FC<ProductProps> = (props:ProductProps) => {
    const product : ClampexType = props.match.params.id;
    const location = useLocation();
    const params:ProductInputDataURL = queryString.parse(location.search);
    
    /*console.log("PROPS:",props);

    const authResult = new URLSearchParams(window.location.search); 
    const code = authResult.get('code');
    console.log("CODE",code);
*/

    
    const defaultProductFields: ProductInputData = {
        c_value: params.c_value,
        hubInnerDiameter_D:  params.hid,
        hubOuterDiameter:  params.hod,
        torque: params.torque,
        axialForce: params.af,
        rotationSpeed: params.rs,
        yieldStrengthShaft: params.yss,
        shaftDiameter_d: params.sd,
        shaftInnerDiameter_diw: params.sid,
        yieldStrengthHub: params.ysh,
        screwBoltingTorqueOverwritePercentage: Number(params.sbtop),
        screwBoltingTorque_Ts: params.sbt,
    };


    const KTR150fields = {
        c_value: null,
        hubInnerDiameter_D:  null,
        hubOuterDiameter:  null,
        torque: null,
        axialForce: null,
        rotationSpeed: null,
        yieldStrengthShaft: null,
        shaftDiameter_d: null,
        shaftInnerDiameter_diw: null,
        yieldStrengthHub: null,
        screwBoltingTorqueOverwritePercentage: 0,
        screwPreloadForce: null
    };

    const KTR700fields = {
        torque: null,
        axialForce: null,
        rotationSpeed: null,
        yieldStrengthShaft: null,
        shaftDiameter_d: null,
        shaftInnerDiameter_diw: null,
        screwBoltingTorqueOverwritePercentage: 0,
        screwBoltingTorque_Ts: null,
    }   

    
    store.dispatch(fetchMaterials());

    switch(props.match.params.id) {
        case ClampexType.KTR100: 
        case ClampexType.KTR105: 
        case ClampexType.KTR130:
        case ClampexType.KTR131:
        case ClampexType.KTR200:
        case ClampexType.KTR201:
        case ClampexType.KTR203:
        case ClampexType.KTR206:
        case ClampexType.KTR225:
        case ClampexType.KTR250:
        case ClampexType.KTR400:
                store.dispatch(updateProduct(product));
                store.dispatch(fetchProductSizes(product));
                store.dispatch(fetchProductCValues(product));
                store.dispatch(updateInputData(defaultProductFields))
                store.dispatch(fetchMetadata(product));
            return (<div></div>)
        case ClampexType.KTR150:
                store.dispatch(updateInputData(KTR150fields))
                store.dispatch(updateProduct(product));
                store.dispatch(fetchProductSizes(product));
                store.dispatch(fetchProductCValues(product));
                store.dispatch(fetchMetadata(product));
            return (null)
        case ClampexType.KTR700:
                store.dispatch(updateInputData(KTR700fields))   
                store.dispatch(updateProduct(product));
                store.dispatch(fetchProductSizes(product));
                store.dispatch(fetchProductCValues(product));
                store.dispatch(fetchMetadata(product));
           
            return (<div></div>)
        default: //If no react router value is passed set to default product KTR100
                store.dispatch(updateInputData(defaultProductFields))
                store.dispatch(updateProduct(ClampexType.KTR100));
                store.dispatch(fetchProductCValues(ClampexType.KTR100));
                store.dispatch(fetchProductSizes(ClampexType.KTR100));
                store.dispatch(fetchMetadata(ClampexType.KTR100));
                //store.dispatch(updateInputData(defaultProductFields))
            return (<div></div>)
    }
    
}
export default ProductLookup;


